import { Color, Vector4 } from 'three';
export function packShading(shading = '#ffffff', opacity = 1) {
    const result = new Vector4();
    const shadingColor = new Color(shading);
    result.set(shadingColor.r, shadingColor.g, shadingColor.b, 1);
    result.setW(opacity);
    return result;
}
